module.exports = __webpack_public_path__ + "static/media/logo.f30582e2.svg";